<template>
	<div class="breadcrumb-preview">
		<el-breadcrumb :style='{"fontSize":"18px","lineHeight":"1","justifyContent":"center","display":"flex"}' separator="/">
			<transition-group name="breadcrumb" class="box">
				<el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
					<span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{changeInList(item)}}</span>
					<a v-else @click.prevent="handleLink(item)">
						<span class="icon iconfont icon-shouye-zhihui" :style='{"margin":"0 2px","lineHeight":"1","fontSize":"16px","color":"#ff7b54"}'></span>首页
					</a>
				</el-breadcrumb-item>
			</transition-group>
		</el-breadcrumb>
	</div>
</template>

<script>
	import pathToRegexp from 'path-to-regexp'
	import { generateTitle } from '@/utils/i18n'
	export default {
		data() {
			return {
				levelList: null
			}
		},
		watch: {
			$route() {
				this.getBreadcrumb()
			}
		},
		created() {
			this.getBreadcrumb()
		},
		methods: {
			changeInList(row) {
				if (row.path == '/config/:type') {
					console.log(111)
					console.log(this.$route.params.type)
					if (this.$route.params.type == 1) {
						return '轮播图管理'
					} else if (this.$route.params.type == 3) {
						return '背景图管理'
					}
				}
				return row.name
			},
			generateTitle,
			getBreadcrumb() {
				// only show routes with meta.title
				let route = this.$route
				let matched = route.matched.filter(item => item.meta)
				const first = matched[0]
				matched = [{ path: '/index' }].concat(matched)

				this.levelList = matched.filter(item => item.meta)
			},
			isDashboard(route) {
				const name = route && route.name
				if (!name) {
					return false
				}
				return name.trim().toLocaleLowerCase() === 'Index'.toLocaleLowerCase()
			},
			pathCompile(path) {
				// To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
				const { params } = this.$route
				var toPath = pathToRegexp.compile(path)
				return toPath(params)
			},
			handleLink(item) {
				const { redirect, path } = item
				if (redirect) {
					this.$router.push(redirect)
					return
				}
				if(path){
					this.$router.push(path)
				}else{
					this.$router.push('/')
				}
			},
		}
	}	
</script>

<style lang="scss" scoped>
	.el-breadcrumb {
		& /deep/ .el-breadcrumb__separator {
						margin: 0 9px;
						color: #ff845a50;
						font-weight: 500;
					}
		
		& /deep/ .el-breadcrumb__inner a {
						color: #ff7b54;
						display: inline-block;
					}
		
		& /deep/ .el-breadcrumb__inner {
						color: #ff7f00;
						display: inline-block;
					}
	}
</style>
